import { render, staticRenderFns } from "./insurancePolicy.vue?vue&type=template&id=cf316cb6&scoped=true"
import script from "./insurancePolicy.vue?vue&type=script&lang=js"
export * from "./insurancePolicy.vue?vue&type=script&lang=js"
import style0 from "./insurancePolicy.vue?vue&type=style&index=0&id=cf316cb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf316cb6",
  null
  
)

export default component.exports